import gql from 'graphql-tag';
import { getUserId } from '../../localStorages';

export default ({ id, status, reason }) => {
  const updateStatusAccount = `updateStatus(input: { id: "${id}", status: ${status}, reason: ${reason}, userId: ${`"${getUserId()}"` ||
    ''}})`;
  return gql`
  mutation {
    ${updateStatusAccount} {
      id
      status
      reason
    }
  }
`;
};
